import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';

import CTAButton from '../../CTAButton';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
`;

const TabControls = ({ isLast, onNext, t }) => (
  <ButtonContainer>
    {!isLast && <CTAButton type="button" onClick={onNext} text={t('next')} />}
    {isLast && <CTAButton className="oc-cta-button" element="button" text={t('submit')} type="submit" />}
  </ButtonContainer>
);

TabControls.propTypes = {
  isLast: PropTypes.bool,
  onNext: PropTypes.func,
  t: PropTypes.func,
};

TabControls.defaultProps = {
  isLast: false,
  onNext: () => {},
  t: () => {},
};

export default TabControls;
